<template>
	<div>
		<loading-modal v-if="isLoadingPerformanceReview" loading-text="Loading Discussion..." />
		<div v-else>
			<div v-if="hasAccess">
				<performance-review-discussion 
					:performance-review="performanceReview"
					:logged-in-employee="loggedInEmployee"
					:allow-reviewer-completion-without-employee-submission="allowReviewerCompletionWithoutEmployeeSubmission"
					:is-updating-item="isUpdatingItem"
					@onShowItemEditor="onShowItemEditor"></performance-review-discussion>
			</div>
			<div v-else>
				You do not have access to this resource
			</div>

			<performance-review-discussion-item-editor
				v-if="showItemEditor"
				:dialog="showItemEditor"
				:item="editedItem" 
				:is-updating-item="isUpdatingItem"
				@save="onUpdateItem" 
				@closeEditor="onCancelUpdateItem"/>
		</div>

		<v-snackbar v-model="snackbar.show" top :color="snackbar.color" :timeout="snackbar.timeout">
			{{snackbar.message}}
			<v-btn :color="snackbar.buttonColor" flat @click="snackbar.show = false">
				Close
			</v-btn>
		</v-snackbar>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import PerformanceReviewDiscussion from '@/components/performanceReview/PerformanceReviewDiscussion';
	import PerformanceReviewDiscussionItemEditor from '@/components/performanceReview/PerformanceReviewDiscussionItemEditor';
	import LoadingModal from '@/components/LoadingModal';

	export default {
		name: 'PagePerformanceReviewDiscussion',
		props: {
			id: {
				required: true
			}
		},
		components: {
			PerformanceReviewDiscussion,
			PerformanceReviewDiscussionItemEditor,
			LoadingModal
		},
		data() {
			return {
				performanceReview: null,
				isLoadingPerformanceReview: false,
				isUpdatingItem: false,
				showItemEditor: false,
				editedItem: undefined,
				snackbar: {
					show: false,
					message: '',
					color: undefined,
					buttonColor: 'pink',
					timeout: 6000
				},
			};
		},
		async created() {
			this.$store.dispatch('setPageTitle', 'Review Discussion');
			
			this.isLoadingPerformanceReview = true;
			try {
				this.performanceReview = await this.$store.dispatch('performanceReviews/getById', this.id);
			} catch(err) {
				this.showSnackbar('Failed to retrieve Performance Review.', true);
			} finally {
				this.isLoadingPerformanceReview = false;
			}
		},
		computed: {
			...mapGetters({
				loggedInEmployee: 'loggedInEmployee',
				loggedInTenant: 'loggedInTenant'
			}),
			allowReviewerCompletionWithoutEmployeeSubmission() {
				return !!(
					this.loggedInTenant &&
					this.loggedInTenant.tenantSettings &&
					this.loggedInTenant.tenantSettings.allowReviewerCompletionWithoutEmployeeSubmission
				);
			},
			hasAccess() {
				if (this.performanceReview != null) {
					return this.isComplete || this.loggedInEmployee.isAdmin || this.loggedInEmployee.id == this.performanceReview.reviewer.id;
				}
				return false;
			},
			isComplete() {
				return this.performanceReview.status === 'Complete';
			}
		},
		methods: {
			onShowItemEditor(item) {
				this.editedItem = item;
				this.showItemEditor = true;
			},
			onUpdateItem(item) {
				this.isUpdatingItem = true;

				const payload = {
					...item,
					performanceReviewId: this.performanceReview.id,
					submitId: this.performanceReview.reviewerSubmit.id,
					id: item.id
				}

				this.$store.dispatch('performanceReviews/updateSubmitItem', payload).then(data => {
					this.performanceReview = data;
					this.showItemEditor = false;
					this.showSnackbar('Changes Saved');
				}).catch(error => {
					this.showSnackbar('An error occurred updating the answer. Please contact support.', true);
				}).finally(() => {
					this.isUpdatingItem = false;
				});
			},
			onCancelUpdateItem(item) {
				this.editedItem = undefined;
				this.showItemEditor = false;
			},
			showSnackbar(message, isError) {
				this.snackbar.show = true;
				this.snackbar.message = message;
				this.snackbar.color = isError ? 'error' : undefined;
				this.snackbar.buttonColor = isError ? '#fff' : 'pink';
				this.snackbar.timeout = isError ? 0 : 6000
			},
		}
	};
</script>

<style></style>
